// Ids match the insert order in prisma/migrations/20260729190000_firestore_migration_seeds/migration.sql; promotions-credits-constants.test.ts pins the names.
export var PromotionCreditType;
(function (PromotionCreditType) {
    PromotionCreditType[PromotionCreditType["OVERPAYMENT"] = 1] = "OVERPAYMENT";
    PromotionCreditType[PromotionCreditType["PROMOTION"] = 2] = "PROMOTION";
    PromotionCreditType[PromotionCreditType["DEFECT"] = 3] = "DEFECT";
    PromotionCreditType[PromotionCreditType["SHELF"] = 4] = "SHELF";
    PromotionCreditType[PromotionCreditType["EVENT_DISPLAY_SPONSORSHIP"] = 5] = "EVENT_DISPLAY_SPONSORSHIP";
    PromotionCreditType[PromotionCreditType["CREDIT_MEMO"] = 6] = "CREDIT_MEMO";
    PromotionCreditType[PromotionCreditType["SPECIAL_PRICING"] = 7] = "SPECIAL_PRICING";
    PromotionCreditType[PromotionCreditType["OTHER"] = 8] = "OTHER";
    PromotionCreditType[PromotionCreditType["QUARANTINE"] = 9] = "QUARANTINE";
    PromotionCreditType[PromotionCreditType["REVERSE_MANIFEST"] = 10] = "REVERSE_MANIFEST";
})(PromotionCreditType || (PromotionCreditType = {}));
//# sourceMappingURL=promotion-credit-type.js.map